import axios from 'axios'

type RequestHeaders = Record<string, string | string[] | undefined>

export interface FetchBannerSearchParams {
  type: 'search' | 'category' | 'collection' | 'url'
  value: string
  headers?: RequestHeaders
}

interface BannerImage {
  url: string
  width: number
  height: number
}

export interface BannerSearchResponse {
  label: string
  entryId: string
  promotionId: string
  promotionName: string
  creativeName: string
  creativeSlot: string
  imageDesktop?: BannerImage
  imageMobile?: BannerImage
  urlRedirect: string
  matchMode: string
}

export const fetchBannerSearch = async ({
  type,
  value,
  headers
}: FetchBannerSearchParams): Promise<BannerSearchResponse | null> => {
  try {
    const isClient = typeof window !== 'undefined'
    const url = isClient
      ? '/api/catalog/banners/search'
      : `${process.env.NEXT_PUBLIC_BFF_ECOMMERCE}/catalog/banners/search`

    const response = await axios.get(url, {
      params: {
        type,
        value
      },
      headers: {
        ...headers,
        ...(isClient ? { 'x-bff-target': 'ecommerce' } : {})
      }
    })
    return response.data
  } catch (error) {
    console.error('Error fetching banner search:', error)
    return null
  }
}
